<div class="d-flex justify-content-end mb-3">
  <button
    id="adminorcustomer_organizations_soarrules_serverexceptions_addnew"
    type="button"
    class="cyflare-btn-primary"
    (click)="openEditor()"
  >
    Add new
  </button>
</div>

@if (datatableUrl(); as url) {
  <app-datatable
    [data-href]="url"
    [columns]="datatableColumns"
    [useOData]="true"
    (click)="onTableClick($event)"
  ></app-datatable>
}

@if (formGroup(); as form) {
  <kendo-dialog
    [title]="isNew() ? 'Add Server Exception' : 'Edit Server Exception'"
    [width]="520"
    [minWidth]="340"
    (close)="closeEditor()"
  >
    <form [formGroup]="form">
      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_serverexceptions_servername"
        >
          Host Name
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_serverexceptions_servername"
          class="form-control"
          formControlName="server_name"
        />
      </div>

      <div class="mb-3">
        <label class="form-label small text-muted mb-1">Server Type</label>
        <kendo-dropdownlist
          id="adminorcustomer_organizations_soarrules_serverexceptions_servertype"
          [data]="listData"
          textField="text"
          valueField="value"
          [valuePrimitive]="true"
          formControlName="server_type"
        ></kendo-dropdownlist>
      </div>

      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_serverexceptions_ipaddress"
        >
          IP Address
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_serverexceptions_ipaddress"
          class="form-control"
          formControlName="ip_address"
        />
      </div>

      <div class="mb-2">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_serverexceptions_notesforanalyst"
        >
          Analyst Notes
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_serverexceptions_notesforanalyst"
          class="form-control"
          formControlName="notes_for_analyst"
        />
      </div>
    </form>

    <kendo-dialog-actions>
      <button
        id="adminorcustomer_organizations_soarrules_serverexceptions_cancel"
        type="button"
        class="cyflare-btn-secondary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="closeEditor()"
      >
        Cancel
      </button>
      <button
        id="adminorcustomer_organizations_soarrules_serverexceptions_save"
        type="button"
        class="cyflare-btn-primary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="save()"
      >
        @if (isSaving()) {
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
          ></span>
          Saving...
        } @else {
          {{ isNew() ? 'Add' : 'Update' }}
        }
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
